import { render } from "./LastSeenBoxComponent.vue?vue&type=template&id=dc725cd2"
import script from "./LastSeenBoxComponent.vue?vue&type=script&lang=js"
export * from "./LastSeenBoxComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__